module.exports = __webpack_public_path__ + "static/media/32.01e2cb0c.mp3";